import {SET_ACTIVE_ANNOTATION, UNSET_ACTIVE_ANNOTATION} from '../actiontypes';

export function setActiveAnnotationId(activeAnnotationId) {
	return {
		type: SET_ACTIVE_ANNOTATION,
		data: {
			activeAnnotationId
		}
	};
}

export function unsetActiveAnnotationId() {
	return {
		type: UNSET_ACTIVE_ANNOTATION
	};
}
